import React, { useEffect, useState } from "react";

import { Header } from "components/Header";
import { SearchBar } from "components/SearchBar";
import { DataTable } from "components/DataTable";
import { AlertModal } from "components/Modals/AlertModal";

import { IMaintenance } from "interfaces/Maintenance";

import { DashboardTemplate } from "templates/DashboardTemplate";

import { CheckAlert } from "utils/checkAlert";
import debouncer from "utils/debouncer";

import { IFilterWhereOptions, useDataList } from "hooks/useDataList";
import { StepRegisterMaintenance } from "components/Modals/StepRegister/StepRegisterMaintenance";
import { MoreMaintenanceDetailsModal } from "components/Modals/MoreMaintenanceDetailsModal";
import { activeMaintenance, deleteMaintenance } from "services/MaintenanceService";
import * as S from './styles'
import ExportMaintenanceModal from "components/Modals/ExportMaintenanceModal";
import { CommentsModal } from "components/Modals/CommentsModal";

export function Maintenance() {
  const [page, setPage] = useState(1);
  const [exportModal, setExportModal] = useState<boolean>(false);
  const [maintenance, setMaintenance] = useState<IMaintenance | undefined>();
  const [filterWhere, setFilterWhere] = useState<IFilterWhereOptions<IMaintenance>>()

  const [registerModal, setRegisterModal] = useState(false);
  const [dataModal, setDataModal] = useState(false);
  const [commentModal, setCommentModal] = useState(false);
  const [activationModal, setActivationModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const { data, isFetching } = useDataList<IMaintenance>({
    queryKey: 'listAllMaintenance',
    route: 'maintenance',
    filter: {
      size: 10,
      page,
      params: filterWhere,
      relations: { client:true },
      order:{
        createdAt: 'DESC'
      }
    }
  })

  useEffect(() => {
    CheckAlert();
  }, []);

  function handleMenuClick(menuItemId: string, data: IMaintenance) {
    if (!data) return;

    setMaintenance(data)

    setTimeout(() =>{
      switch (menuItemId) {
        case "comment":
          setCommentModal(true);
          break;
        case "data":
          setDataModal(true);
          break;
        case "edit":
          setRegisterModal(!registerModal);
          break;
        case "activate":
          setActivationModal(!activationModal);
          break;
        case "deactivate":
          setDeleteModal(!deleteModal);
          break;
      }
    },0)
  }

  function handleSearchChange(queryString: string) {
    if (queryString) {
      return setFilterWhere([
        {protocol:`%${queryString}%`},
        {plate: queryString },
        {client:{name:`%${queryString}%`}},
        {requester:`%${queryString}%`},
        {driver:`%${queryString}%`},
      ])
    }
  }

  const debounceClientSearch = debouncer(handleSearchChange, 800);

  return (
    <DashboardTemplate
      hasTableWrapper
      total={data?.total || 0}
      page={page}
      setPage={setPage}
    >
      <Header title="Manutenção" />
      <SearchBar
        type="text"
        name="filter"
        id="filter"
        placeholder="Procure por nome, CNPJ, produto..."
        buttonText="Cadastrar pedido de manutenção"
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          if (event.target.value) {
            debounceClientSearch(event.target.value)
          } else {
            setFilterWhere(undefined);
          }
        }}
        required={false}
        onClick={() => { 
          setMaintenance(undefined)
          setRegisterModal(true);
        }
      }
      Button= {
        <S.Button
          onClick={()=>{
            setExportModal(true);
          }}
        >
          Exportar
        </S.Button>}
      />

      <DataTable
        data={data?.items}
        isFetching={isFetching}
        headers={[
          { field: "protocol", label: "Protocolo"},
          { field: "active", label: "Registro", type: "status" },
          { field: "plate", 
            label: "Veiculo",
            renderColumn: (maintenance) => <span>{maintenance.plate}</span>,
          },
          { field: "requester", label: "Solicitante" },
          { field: "client", 
            label: "Cliente",
            renderColumn: (maintenance) => <span>{maintenance.client.name}</span>,
          },
          { field: "createdAt", 
            label: "Data de criação",
            renderColumn: (data) =>
              new Date(data.createdAt).toLocaleDateString("pt-BR", {
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "numeric",
                minute: "numeric",
              }),
           },
        ]}
        menuActions={[
          {
            id: "data",
            label: "Dados de solicitação",
            onClick: handleMenuClick,
          },
          { id: "edit", 
            label: "Editar solicitação", 
            onClick: handleMenuClick 
          },
          { id: "comment", 
            label: "Comentários", 
            onClick: handleMenuClick 
          },
          {
            id: "activate",
            label: "Ativar solicitação",
            onClick: handleMenuClick,
            hide: (data) => !data.active,
          },
          {
            id: "deactivate",
            label: "Desativar solicitação",
            onClick: handleMenuClick,
            hide: (data) => data.active,
          },
        ]}
      />

      <StepRegisterMaintenance
        opened={registerModal}
        setOpened={() => {
          if(maintenance)
            setMaintenance(undefined)
          
          setRegisterModal(false);
        }}
        data={maintenance}
      />

      {dataModal && maintenance && (
        <MoreMaintenanceDetailsModal
          modalIsOpen={dataModal}
          setIsOpen={setDataModal}
          data={maintenance}
        />
      )}
    <ExportMaintenanceModal
      modalIsOpen={exportModal}
      setIsOpen={()=>{setExportModal(false)}}
    />
      <AlertModal
        isOpen={deleteModal}
        onRequestClose={() => {
          setMaintenance(undefined)
          setDeleteModal(false)
        }}
        title={`Deseja desativar o solicitação?`}
        text="A solicitação sera considera inválida. Contudo, basta ativá-la novamente."
        confirmButtonText="Sim, desativar"
        confirmButtonClick={() => {
          if(maintenance)  
            deleteMaintenance(maintenance.id);
            window.location.reload();
        }}
      />
      <CommentsModal
        modalIsOpen={commentModal}
        setIsOpen={()=>{setCommentModal(false)}}
        maintenanceId={maintenance?.id}
      />
      <AlertModal
        isOpen={activationModal}
        onRequestClose={() => {
          setMaintenance(undefined)
          setActivationModal(false)
        }}
        title={`Deseja reativar a solicitação ?`}
        text="Isso irá sinalizar a todos que este é uma solicitação válida, Deseja continuar?"
        confirmButtonText="Sim, reativar solicitação"
        confirmButtonClick={() => {
          if(maintenance)  
            activeMaintenance(maintenance.id);
            window.location.reload();
        }}
      />
    </DashboardTemplate>
  );
}
